import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Деталі профілю")
  ])
], -1)
const _hoisted_3 = { class: "card-body border-top p-9" }
const _hoisted_4 = { class: "row mb-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Аватар", -1)
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/blank.png)"}
}
const _hoisted_8 = ["disabled", "data-kt-indicator"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_11 = ["disabled", "data-kt-indicator"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "Дозволені формати файлів: gif,jpg,jpeg,png,webp.", -1)
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Повне ім'я", -1)
const _hoisted_18 = { class: "col-lg-8" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-lg-6 fv-row" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Контактний номер телефону (активний)"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Номер телефону має бути активним"
  })
], -1)
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Email")
], -1)
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_34 = { class: "row mb-0" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, " Додавання нових заявок ", -1)
const _hoisted_36 = { class: "col-lg-8 d-flex align-items-start" }
const _hoisted_37 = { class: "row mb-0" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Відгук/рейтинг", -1)
const _hoisted_39 = { class: "col-lg-8 d-flex align-items-start" }
const _hoisted_40 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_41 = ["disabled", "data-kt-indicator"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-save" }),
  /*#__PURE__*/_createTextVNode("Зберегти")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Будь ласка, чекайте ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueFileUploadComponent = _resolveComponent("VueFileUploadComponent")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_ExclamationNotice = _resolveComponent("ExclamationNotice")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.userData && _ctx.userData.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.files.length > 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.files[0].url})`)
                      }, null, 4))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.userData.settings.settings.avatar ? _ctx.userData.settings.settings.avatar : 'media/avatars/blank.png' })`)
                      }, null, 4)),
                  _createElementVNode("div", {
                    class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
                    disabled: _ctx.in_progress,
                    "data-kt-indicator": _ctx.in_progress ? 'on' : 'off',
                    "data-kt-image-input-action": "change"
                  }, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_VueFileUploadComponent, {
                      class: "bg-white",
                      "post-action": "https://rest.norma4.ks.ua/v1/users/upload-image",
                      extensions: "gif,jpg,jpeg,png,webp",
                      accept: "image/png,image/gif,image/jpeg,image/webp",
                      size: 2024 * 20,
                      headers: {
                                            'Authorization': `Bearer ${_ctx.authToken}`
                                        },
                      data: {
                                            'token': _ctx.userToken,
                                            'login': _ctx.userData.user.login,
                                            'user_type': 'tv',
                                        },
                      drop: true,
                      thread: 3,
                      modelValue: _ctx.files,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.files) = $event)),
                      onInputFilter: _ctx.inputFilter,
                      onInputFile: _ctx.inputFile,
                      ref: "upload"
                    }, null, 8, ["headers", "data", "modelValue", "onInputFilter", "onInputFile"])
                  ], 8, _hoisted_8),
                  (_ctx.userData.settings.settings.avatar != null)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
                        "data-kt-image-input-action": "remove",
                        "data-bs-toggle": "tooltip",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeImage())),
                        disabled: _ctx.in_progress,
                        "data-kt-indicator": _ctx.in_progress ? 'on' : 'off',
                        title: "Видалити аватар"
                      }, _hoisted_14, 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_15
              ])
            ]),
            _createVNode(_component_Form, {
              id: "kt_account_profile_details_form",
              class: "form",
              novalidate: "novalidate",
              onSubmit: _ctx.saveChanges,
              "validation-schema": _ctx.profileDetailsValidator,
              enctype: "multipart/form-data"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_Field, {
                          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                          type: "text",
                          name: "name",
                          autocomplete: "off",
                          placeholder: "ПІБ",
                          value: _ctx.userData.settings.settings.name
                        }, null, 8, ["value"]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_ErrorMessage, { name: "name" })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "phone",
                      class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                      placeholder: "Номер телефону",
                      autocomplete: "off",
                      value: _ctx.userData.settings.settings.phone
                    }, null, 8, ["value"]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_ErrorMessage, { name: "phone" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "email",
                      class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                      placeholder: "Email",
                      autocomplete: "off",
                      value: _ctx.userData.user.email
                    }, null, 8, ["value"]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_ErrorMessage, { name: "email" })
                      ])
                    ])
                  ])
                ]),
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_ExclamationNotice, {
                      bg: _ctx.userData.settings.settings.allow_to_add_request ? 'bg-light-success' : 'bg-light-warning',
                      border: _ctx.userData.settings.settings.allow_to_add_request ? 'border-success' : 'border-warning',
                      icon: _ctx.userData.settings.settings.allow_to_add_request
                                    ? 'media/icons/duotune/general/gen043.svg'
                                    : 'media/icons/duotune/general/gen044.svg',
                      "icon-class": _ctx.userData.settings.settings.allow_to_add_request ? 'svg-icon-success' : 'svg-icon-warning',
                      header: "Додавання нових заявок",
                      msg: _ctx.userData.settings.settings.allow_to_add_request
                                    ? 'Додавання нових заявок для вашого облікового запису дозволено!'
                                    : 'Додавання нових заявок для вашого облікового запису заборонено!',
                      margin: "mb-6"
                    }, null, 8, ["bg", "border", "icon", "icon-class", "msg"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_ExclamationNotice, {
                      header: "Рейтинг / відгук",
                      bg: _ctx.userData.settings.settings.allow_to_rating_and_note_request ? 'bg-light-success' : 'bg-light-warning',
                      border: _ctx.userData.settings.settings.allow_to_rating_and_note_request ? 'border-success' : 'border-warning',
                      icon: _ctx.userData.settings.settings.allow_to_rating_and_note_request
                                    ? 'media/icons/duotune/general/gen043.svg'
                                    : 'media/icons/duotune/general/gen044.svg',
                      "icon-class": _ctx.userData.settings.settings.allow_to_rating_and_note_request ? 'svg-icon-success' : 'svg-icon-warning',
                      msg: _ctx.userData.settings.settings.allow_to_rating_and_note_request
                                    ? 'Додавання відгуку за заявками для вашого акаунта дозволено!'
                                    : 'Додавання відгуку за заявками для вашого акаунта заборонено!',
                      margin: "mb-6"
                    }, null, 8, ["bg", "border", "icon", "icon-class", "msg"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary",
                    disabled: _ctx.in_progress,
                    "data-kt-indicator": _ctx.in_progress ? 'on' : 'off'
                  }, _hoisted_44, 8, _hoisted_41)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}